import { ReasonForGlide } from "common/firebase-function-types";

export const reasonForGlideKey = ["Select", "For fun", "For school", "For work", "Other"] as const;

export type ReasonForGlideKey = typeof reasonForGlideKey[number];

export const reasonsForGlide: Record<ReasonForGlideKey, ReasonForGlide | undefined> = {
    Select: undefined,
    "For work": "work",
    "For school": "school",
    "For fun": "fun",
    Other: "other",
};

export interface OnboardingInfo {
    displayName?: string;
    reasonForGlide?: ReasonForGlide;
    isForWork?: boolean;
    company?: string;
    lineOfWork?: string;
    companySize?: string;
}
